<template>
    <div class="search-item">
        <div class="search-item-title" :style="{ 'flex': '0 0 85px' }">{{ label }}：
        </div>
        <div class="search-item-con">
            <el-button size="mini" class="search-btn" :class="[value == item[keyName] ? 'on' : '']"
                v-for="item in options" :key="item[keyName]" @click="updateValue(item[keyName])">
                {{ item[valueName] }}
            </el-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
        },
        label: {
            type: String,
            default: ''
        },
        keyName: {
            type: String,
            default: 'key'
        },
        valueName: {
            type: String,
            default: 'value'
        },
    },
    methods: {
        updateValue(val) {
            this.$emit('update:value', val)
            this.$emit('search', val)
        }
    }
}
</script>
<style scoped lang="scss">
.search-item {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;

    // width: 100%;
    .search-item-title {
        color: "#606266";
        font-size: 14px;
    }

    .search-item-con {
        display: flex;
        flex-wrap: wrap;

        .search-btn {
            padding: 0 5px;
            line-height: 22px;
            margin: 0 10px 10px 0 !important;

            &.on {
                color: #fff;
                background: $--color-primary;
                border: 1px solid $--color-primary;
            }
        }
    }
}
</style>
